<template>
    <div v-loading="loadingController">
        <div class="btn-content">
            <template v-if="shbj==='0'">
                <ca-activation 
                type="warning" 
                icon="el-icon-s-check" 
                :disabled="!pdfSrc"
                v-if="initialization.isdw==='1'"
                @click="stpHandler($event,'dw')">
                    盖章
                </ca-activation>
                <ca-activation 
                type="warning" 
                icon="el-icon-s-check" 
                :disabled="!pdfSrc"
                v-if="initialization.isfr==='1'"
                @click="stpHandler($event,'fr')">
                    法人签名
                </ca-activation>
            </template>
            <template v-if="shbj==='1'">
                <el-button 
                type="primary" 
                size="medium" 
                :disabled="!pdfSrc"
                icon="el-icon-s-check" 
                @click="resetFile()">
                    重新盖章
                </el-button>
               
            </template>
            
            <el-button @click="cancleHandler">关闭</el-button>
            <el-tag type="danger" style="margin-top:10px">本功能需使用7.9.9及以上版本CA</el-tag>
        </div>
        <div class="pdf-content" :style="{height:pdfHeight}">
            <pdf :src="pdfSrc" ref="pdf"></pdf>
        </div>
        
    </div>
</template>

<script>
import CaActivation from '@/components-sys/ca-activation'
import '@/js/ca/hebei/hebcaP11Object2.js'
import '@/js/ca/CAbase.js'

export default {
    mixins: [],
    components: {
        CaActivation,
    },
    props: {
        row: {
            type: Object,
            default: () => ({})
        },
        procode: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        form: {},
        pdfSrc: '',
        shbj: '0',
        caObjectVal:{},
        typeCode:'',
        initialization:{},
        loadingController: false
    }),
    computed: {
        pdfHeight() {
            return `${window.innerHeight * .7}px`;
        }
    },
    watch: {
        
    },
    methods: {
        // 初始化
        formInit() {
     
            var that = this
            // 初始化数据
            that.$get(`${this.getGetters('mngUrl')}/Zbdl/ZbProject/Zbdlcns/index.json`, {
                zbprocode:this.row.zbprocode
            }, (data, res) => {
                that.initialization = data
                // 请求承诺书
                that.$get(`${this.getGetters('mngUrl')}/Zbdl/ZbProject/Zbdlcns/getCnsPdf.json`, {
                    zbprocode:that.initialization.zbprocode
                }, (data, res) => {
                    var oldSrc = that.pdfSrc;
                    that.pdfSrc = data.filepath.replace(/^http:\/\/[^/]+/, "")
                    
                    if(oldSrc === that.pdfSrc) {
                        setTimeout(() => {
                            that.$refs.pdf.reload();
                        }, 3000);
                    }

                    that.shbj = data.shbj
                });
            });
        },
        // 取消
        cancleHandler(){
            this.$emit('cancle')
        },
        // 重新盖章
        resetFile(){
            var that = this
            that.$post(`${this.getGetters('mngUrl')}/Zbdl/ZbProject/Zbdlcns/resetFile.json`, {
                zbprocode:that.initialization.zbprocode
            }, (data, res) => {
                that.formInit()
            });
        },
        // 调用签章
        stpHandler(val,type) {
            
            try {
                var that = this
                that.typeCode = type
                that.form.caType = val
                that.caObjectVal = that.SelectStampcallback
                //ca单位名称
                useCA(that.form.caType, 'getcadwname', that.objectVal, function (res) {
                    
                    if (getSession('user').dwname == res.cadwname) {
                        // 选择印章
            	        useCA(that.form.caType, 'pdfSelectStamp', that.caObjectVal, function (res) {})
                    }else{
                        ShowMsg('CA单位名称与当前登录单位名称不一致！', 'error');
                        return
                    }
                })
            }
            catch (e) {
                ShowMsgBox(e.message, 'SelectStamp错误');
            }
        },

        //调用SelectStamp接口，用户选择印模，返回印模相关信息:
        // boolean success: true表示操作执行成功
        // string error: 操作执行失败时的错误信息
        // string stamp: 已经选择的印模Base64字符串
        // int isSM2: 是否SM2证书，1标识SM2，0标识非SM2
        SelectStampcallback(success, error, stamp, isSM2) {
            var that = this
            that.loadingController = true
            //在此处添加处理代码...
            if (success) {
                that.$post(`${that.getGetters('mngUrl')}/Zbdl/ZbProject/Zbdlcns/hashpdf.json`, {
                    isSm2Cert: isSM2,
                    stampImgB64: stamp,
                    zbprocode: that.row.zbprocode,
                    type: that.typeCode
                }, data => {
                    var obj = {
                        val:data,
                        fun:that.SealHashcallback
                    }
                    // 生成签章结果
                    useCA(that.form.caType, 'pdfSealHash', obj, function (res) {})
                });
                
            } else {
                that.loadingController = false
                if(!error){
                    ShowMsgBox('<h3>请确认</h3>1、CA锁是否插入<br>2、操作步骤是否正确<br>3、是否取消操作', 'warning',{
                        dangerouslyUseHTMLString: true
                    });
                }else{
                    ShowMsgBox(error, 'SelectStamp错误');
                }
            }
        },

        //调用SealHash接口，根据摘要生成签章结果:
        // boolean success: true表示操作执行成功
        // string error: 操作执行失败时的错误信息
        // string result: 签章结果的Base64字符串
        SealHashcallback(success, error, result) {
            var that = this
            //在此处添加处理代码...
            if (success) {
                that.$post(`${that.getGetters('mngUrl')}/Zbdl/ZbProject/Zbdlcns/mergepdfseal.json`, {
                    signature: result,
                    zbprocode: that.row.zbprocode,
                    type: that.typeCode
                }, data => {
                    that.loadingController = false
                    ShowMsgBox('承诺书盖章成功', 'success');
                    that.formInit()
                });
                
            } else {
                that.loadingController = false
                ShowMsgBox(error, 'SealHash错误');
            }
        },
   
       
    },
    created() {
        this.formInit();
    },
}
</script>

<style scoped lang="scss">
.pdf-content{ height:500px; position:relative; }
.btn-content{text-align:center; margin-top:10px;}
</style>
